import { render, staticRenderFns } from "./_event_today.vue?vue&type=template&id=aee4876c&"
import script from "./_event_today.vue?vue&type=script&lang=js&"
export * from "./_event_today.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports